<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!--Chart content-->
  <div class="row common-page-contentwrap">
    <div class="col-md-12">
      <div [hidden]="pgLoad">
        <div class="adjust loader-container">
          <div class="loader2"></div>
        </div>
      </div>
      <!-- faram, user tabs -->
      <!-- <div [hidden]="!pgLoad" class="row farmuserHeader">
        <div class="metricsList">
          <div class="panel panel-default framuserheaders">
            <div class="panel-body">
              <div class="btn-group btn-group-md col-xs-12 col-md-6">
                <button class="btn btn-primary framsbtn" type="button">Farms</button>
                <button class="btn btn-primary userbtn" type="button">User</button>
              </div>
              <div class="col-xs-12 col-md-6 business_name">
                <h4>{{loginUserBusinessName}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- faram, user tabs end -->
      <!-- breadcrumb -->
      <div [hidden]="!pgLoad" class="row">
        <div class="col-md-12">
          <div class="page-breadcrumb">
            <ul class="page-breadcrumb__trail">
              <li><a>Metrics</a></li>
              <li><a>Farm</a></li>
              <li><a>Stocking Density</a></li>
            </ul>
            <div class="page-breadcrumb__icons">
              <a routerLink="/home" *ngIf="loginUserBusinessCategory != 'Provider'"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
              <a routerLink="/home/dashboard" *ngIf="loginUserBusinessCategory == 'Provider'"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>        
            </div>
          </div>
        </div>
      </div>
      <!-- breadcrumb End -->
      <div class="block" [hidden]="!pgLoad">
        <div class="screen_heading_div">
          <span>Density</span>
        </div>
        <div class="metrics-cards_container row">
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong>  {{charttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="graphselection('doughnut')"
                               [ngClass]="sdType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="graphselection('bar')"
                               [ngClass]="sdType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#sdModal" width="20px" height="17px"
                               (click)="getAllStockingDensityLocationView()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                      <!-- <li><img height="17px" src="../../../../../../assets/img/metrics_icons/list.svg" width="20px"/></li> -->
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="canvasarea">
                      <canvas id="myChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!--list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <p class="panel panel-default x_chart_panel nodata"
                   *ngIf="stockingDensityList && stockingDensityList.length == 0"> No data found</p>
                <div class="panel panel-default" *ngIf="stockingDensityList && stockingDensityList.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchBusiness()" [(ngModel)]="search"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th *ngIf="loginUserBusinessCategory != 'Farm'">Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>Density</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loaderstyle loader2"></div>
                        </div>
                      </div>
                      <tr class="searchfun" *ngFor="let list of stockingDensityList">
                        <td *ngIf="loginUserBusinessCategory != 'Farm'">{{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}</td>
                        <td>{{list && list.name}}</td>
                        <td>{{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}</td>
                        <td>{{list && list.stocking_density}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Stocking density grid-->
      <!-- Location details-->
      <!-- ponds by sd Location details-->
      <div class="modal fade" id="sdModal" role="dialog"
           *ngIf="stockingDensityLocations && stockingDensityLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal"  title="Close Popup">&times;</button>
              <h4 class="modal-title location_heading">Density Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of stockingDensityLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <!--<span>{{village.district}},</span>&nbsp;--><span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading"><span>&#8804;</span> 50 PL/m<sup>2</sup></h3>
                    <h3 class="pull-right doc_count">{{village.lessthan50}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">51 - 70 PL/m<sup>2</sup></h3>
                    <h3 class="pull-right doc_count">{{village.stocking51to70}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">71 - 100 PL/m<sup>2</sup></h3>
                    <h3 class="pull-right doc_count">{{village.stocking71to100}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">101 - 120 PL/m<sup>2</sup></h3>
                    <h3 class="pull-right doc_count">{{village.stocking101to120}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">> 120 PL/m<sup>2</sup></h3>
                    <h3 class="pull-right doc_count">{{village.greaterthan120}}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
